<script setup>

</script>
<template>
  <i class="comm-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M16.8057 4.44446V8.61112H12.639" stroke="#B0B0B0" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.0625 12.0834C14.6111 13.3611 13.7567 14.4575 12.6279 15.2073C11.4992 15.9572 10.1573 16.3199 8.80449 16.2407C7.45169 16.1616 6.16125 15.6449 5.12764 14.7685C4.09403 13.8922 3.37324 12.7036 3.0739 11.382C2.77455 10.0604 2.91286 8.67724 3.46799 7.44105C4.02312 6.20485 4.96499 5.18257 6.15167 4.52825C7.33834 3.87393 8.70554 3.62301 10.0472 3.81332C11.3889 4.00363 12.6324 4.62484 13.5903 5.58336L16.8056 8.61114" stroke="#B0B0B0" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </i>
</template>
<style scoped>

</style>